const state = {
    ill_data: null,
    hos_data: null,
    doctor_data: null,
    jifen_rule_data: null,
    jifen_set_data: null,
    drug_config_data: null,
    active_config_data: null,
    live_data: null,

    pharmacist_data: null,

    staff_data: null,
    staff_type: null,
    selectTreeNode: {},
    clickNode: false,
    searchStaffNode: {},
    searchStaff: {},
    showTree: true,
    treeDataAll: [],

    base_content_type: '',
    now_content_type: '',
};

const mutations = {
    // 编辑病种
    setIllData(state, payload) {
        state.ill_data = payload
    },
    // 编辑医院
    setHosData(state, payload) {
        state.hos_data = payload
    },
    // 编辑医生
    setDoctorData(state, payload) {
        state.doctor_data = payload
    },
    // 编辑药师
    setPharmacistData(state, payload) {
        state.pharmacist_data = payload
    },
    // 编辑积分规则
    setJIFENRuleData(state, payload) {
        state.jifen_rule_data = payload
    },
    // 编辑积分设置
    setJIFENSetData(state, payload) {
        state.jifen_set_data = payload
    },
    // 编辑产品配置
    setDrugConfigData(state, payload) {
        state.drug_config_data = payload
    },
    // 编辑活动管理
    setActiveConfigData(state, payload) {
        state.active_config_data = payload
    },
    // 编辑直播管理
    setLiveData(state, payload) {
        state.live_data = payload
    },
    // 员工模块
    // 编辑员工
    setStaffData(state, payload) {
        state.staff_data = payload.row;
        state.staff_type = payload.type
    },
    // 部门信息
    setStaffTreeNode(state, payload) {
        state.selectTreeNode = payload;
        state.clickNode = !state.clickNode
    },
    setShowTree(state, payload) {
        state.showTree = payload
    },
    setTreeDataAll(state, payload) {
        state.treeDataAll = payload
    },
    // 搜索之后点击部门信息
    setSearchStaffNode(state, payload) {
        state.searchStaffNode = payload
    },
    // 搜索后点击员工
    setSearchStaff(state, payload) {
        state.searchStaff = payload
    },

    // 内容推送模块
    setBaseContentType(state, payload) {
        // 保存上次推送内容类型
        state.base_content_type = payload
    },
    setNowContentType(state, payload) {
        // 保存当前推送内容类型
        state.now_content_type = payload
    }
};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}